//#region Angular Imports

import { StateProvider, StateService } from '@uirouter/angularjs'

//#endregion

import { default as apiModule, Api, LocalDictionaryFactory } from './../api/api.module'

import { default as commonModule, LoggerService } from './../common/common.module'
import { MenuItem } from '../common/sidebar-menu/common.sidebar-menu.directive'

import { UserSession, ConfigHelper } from '../../helpers'
import { OpOperator } from '../../models/core'
import { Activity, Enums } from '../../models/common'

import { SERVICES_MODULE_NAME } from './../../services'
import { GridContextMenuService, GRID_CONTEXT_MENU_SERVICE_NAME } from '../../services/grid'
import { SYSTEM_SERVICE_PROVIDER_NAME, SystemServiceProvider, $SCOPE_SERVICE_NAME, $STATE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, SYSTEM_SERVICE_NAME, SystemService } from '../../services/system'

import { IssuesController, IssuesScope } from './issues.controller'
import { IssueCreateEditDirective } from './create-edit/issues-create-edit.directive'
import { IssueDetailsDirective } from './details/issues-details.directive'
import { IssueCreateIssuesTasksDirective } from './create-issues-tasks/issue-create-issues-tasks.directive'

import { IssueHelper } from './issues.helper'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../services/user-session'

//#region Asset Imports

import * as TEMPLATE from './issues.tpl.html'

//#endregion


// Consts

const CONTROLLER_NAME: string = 'IssueController'
const CREATE_EDIT_DIRECTIVE_NAME: string = 'issueCreateEdit'
const CREATE_ISSUE_TASKS_DIRECTIVE_NAME: string = 'issuesCreateIssuesTasks'
const DETAILS_DIRECTIVE_NAME: string = 'issueDetails'
const MENU_INDEX = 6
const MODULE_NAME: string = 'simax.issues'
const MODULE_NAME_LOCALIZATION_TEXT: string = 'ISSUE_NAME'
const STATE_NAME: string = 'issues'
const STATE_URL: string = '/issues'

// Consts End


// Setup

const module = angular.module(MODULE_NAME, [commonModule, apiModule, SERVICES_MODULE_NAME])

module.controller(CONTROLLER_NAME, [
    $SCOPE_SERVICE_NAME,
    $STATE_SERVICE_NAME,
    $TIMEOUT_SERVICE_NAME,
    'api',
    'logger',
    'localDictionary',
    GRID_CONTEXT_MENU_SERVICE_NAME,
    USER_SESSION_SERVICE_NAME,
    SYSTEM_SERVICE_NAME,
    (
        $scope: IssuesScope,
        $state: StateService,
        $timeout,
        api: Api,
        logger: LoggerService,
        localDictionary: LocalDictionaryFactory,
        gridContextMenuService: GridContextMenuService,
        userSession: UserSessionService,
        systemService: SystemService
    ) => new IssuesController(
        $scope,
        $state,
        $timeout,
        api,
        logger,
        localDictionary,
        gridContextMenuService,
        userSession,
        systemService,
        IssueHelper.REFERENCE_TYPE,
        IssueHelper.SIMAX_MODULE_NAME
    )])

module.directive(DETAILS_DIRECTIVE_NAME, [() => new IssueDetailsDirective()])
module.directive(CREATE_EDIT_DIRECTIVE_NAME, [() => new IssueCreateEditDirective()])
module.directive(CREATE_ISSUE_TASKS_DIRECTIVE_NAME, [() => new IssueCreateIssuesTasksDirective()])

module.config(["$stateProvider", 'userSessionProvider', SYSTEM_SERVICE_PROVIDER_NAME, (
    $stateProvider: StateProvider,
    userSessionProvider: UserSession,
    systemServiceProvider: SystemServiceProvider
) => {

    systemServiceProvider.registerDetailsComponent({
        key: 'Issue_IdIssue',
        componentName: DETAILS_DIRECTIVE_NAME
    })

    userSessionProvider
        .getLoggedOperatorAsync()
        .then((loggedOperator: OpOperator) => {

            if (loggedOperator.hasPermission(Activity.ISSUE_LIST)
                && !loggedOperator.hasPermission(Activity.ISSUE_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.IssueMoodule)) {

                MenuItem.addMenuItem(
                    ConfigHelper.getIconName(ConfigHelper.Icon.ISSUES),
                    'issues',
                    MODULE_NAME_LOCALIZATION_TEXT,
                    STATE_NAME,
                    MENU_INDEX
                )

                $stateProvider.state(STATE_NAME, {
                    url: STATE_URL,
                    controller: CONTROLLER_NAME,
                    template: TEMPLATE,
                    params: { ids: null }
                })
            }
        })
}])

// Setup End


export default MODULE_NAME